import { useContext, useMemo } from 'react'

import { isArray } from 'lodash'

import { GlobalContext } from '../../../Providers/GlobalProvider'
import { Tree } from 'antd'
import { getFullName } from '../../../utils/entities/specialityYear'
import { isEmptyArray } from '../../../utils'

const SPECIALITY_PREFIX = 's-'
const YEAR_PREFIX = 'y-'

const SpecialityYearsTree = ({ checked = [], specialities, onChecked }) => {
  const gc = useContext(GlobalContext)

  const entities = useMemo(() => {
    let entities = []

    if (isArray(specialities)) {
      entities = specialities
    } else if (isArray(gc.specialities)) {
      entities = gc.specialities
    }

    return entities
  }, [specialities, gc.specialities])

  const items = useMemo(() => entities.filter(e => !isEmptyArray(e.specialityYears)).reduce((acc, speciality) => {
    const item = { id: SPECIALITY_PREFIX + speciality.id, label: speciality.name, children: [] }
    acc.specialityKeys[SPECIALITY_PREFIX + speciality.id] = {
      speciality: speciality,
      years: speciality.specialityYears.map(year => year.id)
    }

    if (isArray(speciality.specialityYears)) {
      speciality.specialityYears.forEach(year => {
        acc.yearKeys[YEAR_PREFIX + year.id] = year
        item.children.push({ id: YEAR_PREFIX + year.id, label: getFullName(year) })
      })
    }

    acc.values.push(item)

    return acc
  }, { values: [], specialityKeys: {}, yearKeys: {} }, []))

  const handleCheck = (checkedKeys, { checked, node }) => {
    const checkedValue = node.props.value
    const valueParts = checkedValue.split('-')
    const type = valueParts[0]
    const id = valueParts[1]

    if (type === 's') {
      onChecked(items.specialityKeys[checkedValue].years, checked)
    } else {
      onChecked([Number(id)], checked)
    }
  }

  const checkedKeys = useMemo(() => checked.map(id => YEAR_PREFIX + id), [checked])

  return (
    <Tree
      checkedKeys={checkedKeys}
      onCheck={handleCheck}
      checkable
      selectable={false}
      multiple
      style={{ width: '100%' }}
    >
      {items.values.map(value => (
        <Tree.TreeNode
          value={value.id}
          key={value.id}
          title={value.label}
        >
          {isArray(value.children) && value.children.map(year => (
            <Tree.TreeNode
              value={year.id}
              key={year.id}
              title={year.label}
            />
          ))}
        </Tree.TreeNode>
      ))}
    </Tree>
  )
}

export default SpecialityYearsTree
